import { createSlice } from '@reduxjs/toolkit';

export const referenceDataSlice = createSlice({
	name: 'referenceData',
	initialState: { data: null },
	reducers: {
		referenceDataReducer: (state, action) => {
			state.data = action.payload;
		}
	}
});

export const factListSlice = createSlice({
	name: 'factListData',
	initialState: { data: null },
	reducers: {
		factListReducer: (state, action) => {
			state.data = action.payload;
		}
	}
});

export const loaderSlice = createSlice({
	name: 'isLoading',
	initialState: { isLoading: false },
	reducers: {
		loaderReducer: (state, action) => {
			state.isLoading = action.payload;
		}
	}
});

export const toasterSlice = createSlice({
	name: 'toaster',
	initialState: { data: false },
	reducers: {
		toasterReducer: (state, action) => {
			state.data = action.payload;
		}
	}
});

export const routeSlice = createSlice({
	name: 'router',
	initialState: { data: window?.location?.pathname?.replace('/', '') },
	reducers: {
		routeReducer: (state, action) => {
			state.data = action.payload;
		}
	}
});

export const clientSlice = createSlice({
	name: 'router',
	initialState: { data: null },
	reducers: {
		clientReducer: (state, action) => {
			state.data = action.payload;
		}
	}
});

export const accessTokenSlice = createSlice({
	name: 'accessToken',
	initialState: { data: true },
	reducers: {
		accessTokenReducer: (state, action) => {
			state.data = action.payload;
		}
	}
});

export const clientListSlice = createSlice({
	name: 'clientList',
	initialState: { data: [] },
	reducers: {
		clientListReducer: (state, action) => {
			state.data = action.payload;
		}
	}
});
